function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-60.000000, -433.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.000000, 347.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15,0 L5.45454545,1.88476454 L15,4.06038781 L24.5454545,1.88476454 L15,0 Z M3.40316206,2.55955679 L0,6.95734072 L10.5889328,10.3080332 L14.2766798,5.04930748 L3.48616601,2.58282548 C3.46195507,2.57661216 3.43818808,2.56883906 3.41501976,2.55955679 L3.40316206,2.55955679 Z M26.5968379,2.55955679 C26.5698064,2.56935203 26.5420595,2.57713038 26.513834,2.58282548 L15.7233202,5.04930748 L19.4110672,10.3080332 L30,6.95734072 L26.5968379,2.55955679 Z M14.43083,6.81772853 L11.3003953,11.2853186 C11.1551413,11.490295 10.888883,11.5757927 10.6482213,11.4947368 L3.80632411,9.33074792 L3.80632411,17.6376731 L14.43083,21 L14.43083,6.81772853 Z M15.56917,6.81772853 L15.56917,21 L26.1936759,17.6376731 L26.1936759,9.33074792 L19.3517787,11.4947368 C19.111117,11.5757927 18.8448587,11.490295 18.6996047,11.2853186 L15.56917,6.81772853 Z"
}))))));

const SvgIcProducts = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "21px",
    viewBox: "0 0 30 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-products.a183c3c9.svg";
export { ForwardRef as ReactComponent };